import React, { useMemo } from 'react';

import { mappedItemTypes } from '../../../services/items';
import { ReactComponent as ImagePlaceholder } from '../../../icons/image-placeholder.svg';

const getNodeIcon = (typeId) => {
    for (const type in mappedItemTypes) {
        if (mappedItemTypes[type].id === typeId) {
            return mappedItemTypes[type].icon;
        }
    }

    return ImagePlaceholder;
};

const AutoformIconNode = ({ itemTypeId }) => {
    const Icon = useMemo(() => getNodeIcon(itemTypeId), [itemTypeId]);

    return <Icon />;
};

export default React.memo(AutoformIconNode);
